import { render, staticRenderFns } from "./ItemRecipeIngredientsListItem.vue?vue&type=template&id=2fed00b3&"
import script from "./ItemRecipeIngredientsListItem.vue?vue&type=script&lang=js&"
export * from "./ItemRecipeIngredientsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
